export const createStep = `
    mutation createStep($input: CreateStepInput!) {
        createStep(input:$input) {
            id
            phaseId
            playbookId
            name
            displayName
            description
            position
            taskStateName
            targetService
            targetOperation
            parameters
            createdByUsername
            created
    }
}`;

export const updateStep = `
    mutation updateStep($input: UpdateStepInput!) {
        updateStep(input:$input){
            id
            phaseId
            playbookId
            name
            displayName
            description
            position
            taskStateName
            targetService
            targetOperation
            parameters
            createdByUsername
            created
            updated
        }
}`;

export const deleteStep = `
    mutation deleteStep($input: DeleteStepInput!) {
        deleteStep(input:$input) {
            id
        }
}`;
